import React from "react";
import {NodeField} from "../fields";
import {objects, strings} from "@atttomyx/shared-utils";

const ChooseNodeForm = (props) => {
    const { nodes, excludedIds, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.nodeId);

        onSync(modified);
    };

    return <div className="choose-node-form">
        <div className="field top-margin">
            <NodeField
                required={true}
                nodes={nodes}
                excludedIds={excludedIds}
                value={data.nodeId}
                onChange={(nodeId) => onChange("nodeId", nodeId)}
            />
        </div>
    </div>
};

export default ChooseNodeForm;
